import config from '@/config'

const accumulatorIds = ['A', 'D', 'T', 'VLA', 'A4', 'A5', 'A6', 'A7', 'A8', 'A9', 'A10', 'QU', '7T', '7A', 'ATLT', 'ATLA', 'HSHT', 'HSHA', 'PLT', 'PLA', 'VLT']

const getters = {
  maxSno (state) {
    return state.maxSno
  },
  doBetSlipUpdade (state) {
    return state.doBetSlipUpdade
  },
  addingMiltipleSelections (state) {
    return state.addingMiltipleSelections
  },
  inRefferal (state) {
    return state.inRefferal
  },
  activeBetSlip (state) {
    // console.log('get activeBetSlip: ' + state.activeBetSlip)
    return state.activeBetSlip
  },
  activeBetSlipHistoryTab (state) {
    // console.log('get activeBetSlipHistoryTab: ' + state.historyTab)
    if (window.ctsautoconf.SHOW_BETHISTORY_IN_BETSLIP === true) {
      return state.historyTab
    } else {
      return ''
    }
  },
  isFastBetEnabled (state) {
    return state.enableFastBet
  },
  allowInPlayTeasers (state) {
    return !!config.app.allowInPlayTeasers
  },
  mixedTeasers (state) {
    // alert('state.mixedTeasers: ' + state.mixedTeasers)
    return state.mixedTeasers
  },
  tradingBalance (state, rootGetters, getters) {
    var walletBalances = getters.walletBalance
    var walletBalance = (walletBalances && walletBalances.balances && walletBalances.balances.find(balance => balance.type === 'RM')) || {}
    // console.log('externalWalletBalance:')
    // console.log(externalWalletBalance)
    var bonusWalletBalance = (walletBalances && walletBalances.balances && walletBalances.balances.find(balance => balance.type === 'AVAILABLE_BONUS')) || {}
    // console.log('bonusWalletBalance:')
    // console.log(bonusWalletBalance)
    var tradingBalance = (walletBalance.amount || 0) + (bonusWalletBalance.amount || 0)
    return tradingBalance
  },
  mobileFeedback (state) {
    return state.mobileFeedback
  },
  closeFromParent (state) {
    return state.closeFromParent
  },
  accumulatorIds (state) {
    return accumulatorIds
  },
  autoAcceptSbTnC (state) {
    return state.autoAcceptSbTnC
  },
  dismissErrorFromSelection (state) {
    return state.dismissErrorFromSelection
  },
  dismissErrorFromSelectionId (state) {
    return state.dismissErrorFromSelectionId
  },
  minStake (state) {
    return state.stakeLimits.min
  },
  maxStake (state) {
    return state.stakeLimits.max
  },
  stakeLimits (state) {
    return state.stakeLimits
  },
  attemptedBetSlip (state) {
    return state.attemptedBetSlip
  },
  handicapChanged (state) {
    return state.handicapChanged
  },
  confirmBetPlacement (state) {
    return state.confirmBetPlacement
  },
  showAcceptingChangesInfo (state) {
    return state.showAcceptingChangesInfo
  },
  interRelated (state) {
    return state.interRelated
  },
  getSelectionsByTab: (state) => (tab) => {
    return tab
  },
  getTeaserSrcSelectionsBySport: (state, getters) => (sport) => {
    var selections = state.betslipSelections.filter(function (selection) {
      return selection.idfosporttype === sport
    }).map(function (s) {
      return s.idfoselection
    })
    return selections
  },
  getTeaserSrcSelectionsBySportAndPricetype: (state, getters) => (data) => {
    var sport = data[0]
    var pricetype = data[1]
    var selections = state.betslipSelections.filter(function (selection) {
      return selection.idfosporttype === sport && state.teasers.T[pricetype][selection.idfoselection]
    }).map(function (s) {
      return s.idfoselection
    })
    return selections
  },
  getTeaserSelectionsBySport: (state, getters) => (betTypeObj) => {
    var selections = []
    // console.log('getTeaserSelectionsBySport:')
    // console.log(betTypeObj)
    var sport = betTypeObj.teaserSportType
    var selectedTeaser = betTypeObj.selectedTeaser[sport]
    if (selectedTeaser) {
      var teasers = getters.teasers
      var teaserSelections = getters.teaserSelections[sport]
      // var teaserSports = state.teaserSports
      for (var i = 0; i < teaserSelections.length; i++) {
        var s = teaserSelections[i]
        var id = s.idfoselection || s
        // selections.push(teasers[selectedTeaser][s.idfoselection])
        selections.push(teasers[selectedTeaser][id])
      }
      selections = selections.filter(function (s) {
        return state.optedIn[betTypeObj.tab][s.idfoselectionsource]
      })
    }
    return selections
  },
  getSelectionById: (state, rootState, rootGetters, getters) => (id) => {
    var idfoevent = state.idfoevents[id]
    var idfomarket = state.idfomarkets[id]
    var events = getters['livebettingState/liveEvents']
    // var events = rootGetters.livebettingState.liveEvents
    var event = events && events.find(e => e.idfoevent === idfoevent && !e.isawaitingstart)
    var market = event && event.markets && event.markets.find(m => m.idfomarket === idfomarket)
    var selection = market && market.selections && market.selections.find(s => s.idfoselection === id)
    if (selection) {
      return selection
    }
    return state.betslipSelections.find(function (s) {
      return s.idfoselection === id
    })
  },
  getSelection4AabtnrById: (state, rootState, rootGetters, getters) => (id) => {
    return state.betslipSelections.find(function (s) {
      return s.idfoselection === id
    })
  },
  getStoredSelectionById: (state) => (id, isFastBet) => {
    return isFastBet ? state.singleBetSlip.selection : state.betslipSelections.find(function (s) {
      return s.idfoselection === id
    })
  },
  getMarketById: (state, rootState, rootGetters, getters) => (id) => {
    var idfoevent = state.idfoevents[id]
    var idfomarket = state.idfomarkets[id]
    var events = getters['livebettingState/liveEvents']
    var event = events && events.find(event => event.idfoevent === idfoevent)
    var market = event && event.markets && event.markets.find(m => m.idfomarket === idfomarket)
    return market || state.markets[id]
  },
  getStoredMarketById: (state) => (id) => {
    return state.markets[id]
  },
  getIdfoMarketById: (state) => (id) => {
    return state.idfomarkets[id]
  },
  getIdfoEventById: (state) => (id) => {
    return state.idfoevents[id]
  },
  getSelectionsForBetType: (state) => {
    var formatHandicap = function (selection) {
      var h = selection && (selection.currenthandicap || selection.currentmatchhandicap)
      h = h && !isNaN(h) ? parseFloat(h) : ''
//        var h = selection.currenthandicap && !isNaN(selection.currenthandicap) ? parseFloat(selection.currenthandicap) : ''
      if (h) {
        if (selection.hadvalue === 'D' || selection.hadvalue === 'A') {
          if (h) {
            h *= -1
          }
        }
        if (selection.hadvalue === 'H' || selection.hadvalue === 'D' || selection.hadvalue === 'A') {
          if (h > 0) {
            h = '+' + h
          }
        }
        /*
        if (selection.hadvalue === 'O' || selection.hadvalue === 'U') {
          var market = state.markets[selection.idfoselection]
          console.log('O/U')
          console.log(market)
        }
        */
        h = ' ' + h
      }
      return h
    }
    return state.betslipSelections.map(function (selection) {
      return selection.name + formatHandicap(selection)
    })
  },
  clearMarkings: (state) => {
    return state.clearMarkings
  },
  getMarkets: (state) => {
    return state.markets
  },
  teaserSports (state) {
    return state.teaserSports
  },
  teaserSpreads (state) {
    return state.teasers.spreads
  },
  doUpdateTeaser (state) {
    return state.teasers.doUpdate
  },
  optedInRR (state) {
    return state.optedIn.RR
  },
  optedInTeaser (state) {
    return state.optedIn.TEASER
  },
  isOptedIn: (state) => (data) => {
    return !!state.optedIn[data.tab][data.id]
  },
  tab (state) {
    return state.tab
  },
  singleBetSlip (state) {
    return state.singleBetSlip.selection
  },
  betTypeStakes (state) {
    return state.betTypeStakes
  },
  returns (state) {
    return state.returns
  },
  gettingABTnR (state) {
    return state.gettingABTnR
  },
  betPlacementResult (state) {
    return state.betPlacementResult
  },
  betSlipStatus (state) {
    return state.betSlipStatus
  },
  currentBetSlipState (state) {
    return state.currentBetSlipState
  },
  currentBetSlipStateName (state) {
    return state.betSlipState[state.currentBetSlipState]
  },
  inRunningDelay (state) {
    return state.inRunningDelay
  },
  gracePeriod (state) {
    return state.gracePeriod
  },
  gracePeriodTimedOut (state) {
    return state.gracePeriodTimedOut
  },
  betslipSelections (state) {
    return state.betslipSelections
  },
  betslipSelectionsByTab: (state) => (tab) => {
    var selections = state.betslipSelections
    if (tab === 'RR') {
      selections = selections.filter(function (s) {
        return state.optedIn[tab][s.idfoselection]
      })
    }
    return selections
  },
  betslipSelectionIdsByTab: (state) => (tab) => {
    var selections = state.betslipSelectionIds
    // if (tab === 'RR') {
    if (tab !== 'REGULAR') {
      selections = selections.filter(function (s) {
        return state.optedIn[tab][s]
      })
    }
    return selections
  },
  teaserSelections (state) {
    // console.log('teaserSelections')
    var sport
    var i
    var sports = state.teaserSports
    // sports = [0, 1, 2, 3, 4, 5, 6, 7]
    var selections = {
      NFL: [],
      BASKETBALL: [],
      MIXED: [],
      map: {
        MIXED: {}
      }
    }
    var mapSelection = function (t, id, sport) {
      selections.map[sport] = selections.map[sport] || {}
      if (id in state.teasers.T[t]) {
        selections.map[sport][t] = selections.map[sport][t] || []
        selections.map[sport][t].push(id)
        if (state.mixedTeasers) {
          sport = 'MIXED'
          selections.map[sport] = selections.map[sport] || {}
          selections.map[sport][t] = selections.map[sport][t] || []
          selections.map[sport][t].push(id)
        }
      }
    }

    if (state.mixedTeasers) {
      state.betslipSelections.forEach(function (selection) {
        var id = selection.idfoselection
        var idfosporttype = selection.idfosporttype
        var isTeaserSelection = sports.indexOf(idfosporttype) > -1 && ((id in state.teasers.T.T1) || (id in state.teasers.T.T2) || (id in state.teasers.T.T3))
        if (isTeaserSelection) {
          selections[idfosporttype] = selections[idfosporttype] || []
          selections[idfosporttype].push(selection)
          selections['MIXED'] = selections['MIXED'] || []
          selections['MIXED'].push(selection)
          mapSelection('T1', id, idfosporttype)
          mapSelection('T2', id, idfosporttype)
          mapSelection('T3', id, idfosporttype)
        }
        return isTeaserSelection
      })
    } else {
      for (i = 0; i < sports.length; i++) {
        sport = sports[i]
        selections.map[sport] = {}
        selections[sport] = state.betslipSelections.filter(function (selection) {
          var id = selection.idfoselection
          if (selection.idfosporttype === sport) {
            mapSelection('T1', id, sport)
            mapSelection('T2', id, sport)
            mapSelection('T3', id, sport)
          }
          return selection.idfosporttype === sport && ((id in state.teasers.T.T1) || (id in state.teasers.T.T2) || (id in state.teasers.T.T3))
        })
      }
      // return selections

      for (i in state.teasers.teaserGroups) {
        var group = state.teasers.teaserGroups[i]
        if (group.Selections) {
          group.Selections.forEach(function (s) {
            selections[i] = selections[i] || []
            selections[i].push(s.IDFOSelection)
          })
        }
      }
    }
    return selections
  },
  isForTeaserType: (state) => (data) => {
    // console.log('isForTeaserType')
    var idfoselection = data.idfoselection
    var sport = data.sport
    var T = data.selectedTeaser

    var selections = state.betslipSelections.find(function (selection) {
      var id = selection.idfoselection
      return id === idfoselection && selection.idfosporttype === sport && (id in state.teasers.T[T])
    })

    return !!selections
  },
  isForTeaser: (state) => (selection) => {
    var id = selection.idfoselection
    return state.teaserSports.indexOf(selection.idfosporttype) > -1 && ((id in state.teasers.T.T1) || (id in state.teasers.T.T2) || (id in state.teasers.T.T3))
  },
  betslipSelectionsIds (state) {
    return state.betslipSelectionsIds
  },
  betslipSelectionIds (state) {
    return state.betslipSelectionIds
  },
  selectionsNo (state) {
    return state.betslipSelections.length
  },
  allowedBetTypesAndReturnsCnt (state) {
    return state.allowedBetTypesAndReturnsCnt
  },
  allowedBetTypesAndReturns (state) {
    return state.allowedBetTypesAndReturns
  },
  allowedBetTypesAndReturns4T (state) {
    return state.allowedBetTypesAndReturns.TEASER
  },
  allowedBetTypesSING (state) {
    return [state.allowedBetTypesAndReturns.REGULAR.AllowedBetTypes.find(function (bT) {
      return bT.IDFOBetType === 'C1'
      // return bT.IDFOBetType === 'S' || bT.IDFOBetType === 'C1' || bT.BetTypeInstruction === 'C1'
    })]
  },
  allowedBetTypesPRL (state) {
    var ACC = state.allowedBetTypesAndReturns.REGULAR.AllowedBetTypes.filter(function (bT) {
      return accumulatorIds.indexOf(bT.IDFOBetType) > -1
    })
    return ACC
  },
  allowedReturnsPRL (state) {
    /*
    var ACC = []
    if (state.allowedBetTypesAndReturns.REGULAR &&
      state.allowedBetTypesAndReturns.REGULAR.PotentialReturns &&
      state.allowedBetTypesAndReturns.REGULAR.PotentialReturns.PerBetType &&
      state.allowedBetTypesAndReturns.REGULAR.PotentialReturns.PerBetType.length) {
      ACC = state.allowedBetTypesAndReturns.REGULAR.PotentialReturns.PerBetType.filter(function (bT) {
        return accumulatorIds.indexOf(bT.IDFOBetType) > -1
      })
    }
    return ACC
    */
    return state.allowedBetTypesAndReturns.REGULAR.PotentialReturns.PerBetType.A
  },

  allowedBetTypesPRLRR (state) {
    var ACC = state.allowedBetTypesAndReturns.RR.AllowedBetTypes.filter(function (bT) {
      return accumulatorIds.indexOf(bT.IDFOBetType) > -1
    })
    return ACC
  },
  allowedBetTypesRR (state) {
    return state.allowedBetTypesAndReturns.RR.AllowedBetTypes.filter(function (bT) {
      // return bT.IDFOBetType !== 'S' && bT.BetTypeInstruction[0] === 'C' && accumulatorIds.indexOf(bT.BetTypeInstruction) === -1
      return bT.IDFOBetType !== 'S' && bT.IDFOBetType[0] === 'C' && accumulatorIds.indexOf(bT.IDFOBetType) === -1
    })
  },

  allowedBetTypesPRL4T (state) {
    var ACC = state.allowedBetTypesAndReturns.TEASER.NFL.AllowedBetTypes.filter(function (bT) {
      return accumulatorIds.indexOf(bT.IDFOBetType) > -1
    })
    return ACC
  },
  allowedBetTypesRR4T (state) {
    return state.allowedBetTypesAndReturns.TEASER.NFL.AllowedBetTypes.filter(function (bT) {
      // return bT.IDFOBetType !== 'S' && bT.BetTypeInstruction[0] === 'C' && accumulatorIds.indexOf(bT.BetTypeInstruction) === -1
      return bT.IDFOBetType !== 'S' && bT.IDFOBetType[0] === 'C' && accumulatorIds.indexOf(bT.IDFOBetType) === -1
    })
  },
  getClosed (state) {
    return state.betslipSelections.filter(function (s) {
      return s.isclosed
    }).map(function (s) {
      return s.idfoselection
    })
  },
  getSuspended (state) {
    return state.betslipSelections.filter(function (s) {
      return !s.istradable && !s.isclosed
    }).map(function (s) {
      return s.idfoselection
    })
  },
  isEventLive: (state, rootState, rootGetters) => (idfoevent) => {
    return !!rootGetters.livebettingState.liveEvents.find(e => e.idfoevent === idfoevent)
  },
  liveSelections (state, getters) {
    var arr = []
    if (state.betslipSelections.length) {
      state.betslipSelections.forEach(function (selection) {
        var market = state.markets[selection.idfoselection]
        // console.log('LIVE check for: ' + selection.market.idfoevent)
        // if (state.liveTracker[market.idfoevent]) {
        if (getters.isEventLive(market.idfoevent)) {
          arr.push(selection.idfoselection)
        }
      })
    }
    state.liveSelections = arr
    state.isLive = !!arr.length
    return arr
  },
  isBetSlipLive (state) {
    // return state.isLive
    return !!(state.liveSelections && state.liveSelections.length)
  },
  isSelectionLive: (state, getters) => (id) => {
    return getters.liveSelections.indexOf(id) > -1
  },
  betSlipChanges (state) {
    return state.betSlipChanges
  },
  betSlipChangeNo (state) {
    return state.betSlipChanges.changeNo
  },
  teasers (state) {
    return state.teasers.T
  },
  getSourceForTeaserSelection: (state) => (data) => {
    for (var i in state.teasers.T[data[0]]) {
      if (state.teasers.T[data[0]][i].idfoselection === data[1]) {
        return parseFloat(i)
      }
    }
    return null
  },
  activeTeaser (state) {
    return state.teasers.active
  },
  activeTeaserByGroup (state) {
    return state.teasers.activeByGroup
  },
  multiSinglesStake (state) {
    return state.multiSinglesStake
  },
  teaserGroups (state) {
    return state.teasers.teaserGroups
  },
  teaserGroupsNo (state) {
    return state.teasers.teaserGroups ? state.teasers.teaserGroups.length : 0
  },
  pendingGetTeaserGroups (state) {
    return state.teasers.pendingGetTeaserGroups
  },
  teaserGroupId: (state) => (group, toLowerCase) => {
    var teaserGroupId = group && group.IDFOSportType && group.IDFOSportType.split(' ').join('').toUpperCase()
    if (toLowerCase) {
      return teaserGroupId.toLowerCase()
    }
    return teaserGroupId
  },
  autoDismissBetSlip (state) {
    return state.autoDismissBetSlip
  },
  slipTotalStakeMin (state) {
    return state.slipTotalStakeMin
  },
  slipTotalStakeMax (state) {
    return state.slipTotalStakeMax
  },
  slipTotalStakeMaxInPlay (state) {
    return state.slipTotalStakeMaxInPlay
  },
  maxTakeOut (state) {
    return state.maxTakeOut
  },
  isFOPreferredInSingles (state) {
    return state.isFOPreferredInSingles
  },
  isFPPreferredInMultiples (state) {
    return state.isFPPreferredInMultiples
  },
  preferredPriceTypes (state) {
    return {
      isFOPreferredInSingles: state.isFOPreferredInSingles,
      isFPPreferredInMultiples: state.isFPPreferredInMultiples,
      priceTypesToIgnore: state.priceTypesToIgnore
    }
  }
}

export default getters



// WEBPACK FOOTER //
// ./src/store/modules/sports/betslip/getters.js